import { Switch, Route } from "react-router-dom";
import EditPracticeLoans from "../components/practices-loans/edit-practice-loans/edit-practice-loans";

import { PracticesLoansProvider } from "../contexts/practices-loans-context";
import { CustomerProvider } from "../contexts/customer-context";
import { BanksProvider } from "../contexts/banks-context";
import { CommentsProvider } from "../contexts/comments-context";
import { UserProvider } from "../contexts/user-context";
import { ServiceCustomerProvider } from "../contexts/service-customer-context";
import { ServiceProvider } from "../contexts/service-context";
import { FilesProvider } from "../contexts/files-context";
import ListPracticesCardRetrieval from "../components/practices-card-retrieval/list-practices-card-retrieval/list-practices-card-retrieval";
import ListPracticesLoansLegacy from "../components/practices-loans/list-practices-loans/list-practices-loans-legacy";

const PracticesCardRetrieval = ({ match }) => {
  return (
    <div className="practices-page">
      <PracticesLoansProvider>
        <CustomerProvider>
          <CommentsProvider>
            <BanksProvider>
              <UserProvider>
                <ServiceCustomerProvider>
                  <ServiceProvider>
                    <FilesProvider>
                      <Switch>
                        {match.path === "/practices-card-retrieval-legacy" ? (
                          <Route
                            exact
                            path={`${match.path}`}
                            component={ListPracticesLoansLegacy}
                          />
                        ) : (
                          <Route
                            exact
                            path={`${match.path}`}
                            component={ListPracticesCardRetrieval}
                          />
                        )}

                        <Route
                          exact
                          path={`${match.path}/:id`}
                          component={EditPracticeLoans}
                        />
                      </Switch>
                    </FilesProvider>
                  </ServiceProvider>
                </ServiceCustomerProvider>
              </UserProvider>
            </BanksProvider>
          </CommentsProvider>
        </CustomerProvider>
      </PracticesLoansProvider>
    </div>
  );
};

export default PracticesCardRetrieval;
